export const GOLF = '12'; // eslint-disable-line
